import React from 'react';
import * as Styled from '../../Sizes.styles';
export default (function () {
  return /*#__PURE__*/React.createElement(Styled.ResponsiveWrapper, null, /*#__PURE__*/React.createElement(Styled.Table, null, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "\xA0"), /*#__PURE__*/React.createElement("th", {
    className: "th"
  }, "UK"), /*#__PURE__*/React.createElement("th", {
    className: "th"
  }, "EU"))), /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title",
    rowSpan: "17",
    width: "100px"
  }, "Shoe Sizes"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "1"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "17")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "2"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "18")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "3"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "19")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "4"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "20")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "5"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "22")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "6"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "23")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "7"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "24")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "8"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "25")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "9"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "27")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "10"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "28")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "11"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "29")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "12"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "30")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "13"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "32")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "1"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "33")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "2"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "34")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "3"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "36")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "4"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "37")))));
});